// extracted by mini-css-extract-plugin
module.exports = {"container":"ContainerPageSize_container__131ZU"};